import { createAction, props } from '@ngrx/store';
import { IInviteBusinessManagementUserRequest } from '../models/invite-business-management-user.model';

export const loadInviteBusinessManagementUsers = createAction(
  '[InviteBusinessManagementUser] Load InviteBusinessManagementUsers',
  props<{
    groupForUserRoleIds: string[];
    businessId: string;
    userRoleId: string;
    request: IInviteBusinessManagementUserRequest;
  }>()
);

export const loadInviteBusinessManagementUsersSuccess = createAction(
  '[InviteBusinessManagementUser] Load InviteBusinessManagementUsers Success',
  props<{ response: string }>()
);

export const loadInviteBusinessManagementUsersFailure = createAction(
  '[InviteBusinessManagementUser] Load InviteBusinessManagementUsers Failure',
  props<{ error: Error | any }>()
);
